<div class="side-by-side-tabs position-relative">
    <div class="panel-title border-0 mb-3">
        {{data?.msg | titlecase}} Monotainer
    </div>
    <button type="button" class="close" aria-label="Close" title="Close" mat-dialog-close>
        <span aria-hidden="true">&times;</span>
    </button>
    <div [formGroup]="laneTagForm">
        <div class="d-flex mb-3">
            <mat-form-field>
                <mat-label class="cnp-popup-value-headers">Select Monotainers</mat-label>
                <mat-select [disableOptionCentering]="true" formControlName="entity" multiple>
                    <mat-option class="text-capitalize" *ngFor="let option of availableMonotainers" [value]="option._id"
                        selected>
                        <!-- {{option.name | titlecase}} -->
                        {{option.uniqueId}}
                    </mat-option>
                </mat-select>
                <ng-container *ngIf="userSubmit && laneTagFormValues['entity']?.errors">
                    <mat-error *ngIf="laneTagFormValues['entity']?.errors?.['required']">
                        <em class="fas fa-exclamation-circle mr-2"></em>Monotainer is required
                    </mat-error>
                </ng-container>
            </mat-form-field>
        </div>
    </div>
    <div class="btn-basket">
        <button mat-raised-button color="primary" *ngIf="!userSubmit" (click)="resetForm()">Clear</button>
        <button mat-raised-button color="primary" *ngIf="!userSubmit" (click)="submitForm()">Submit</button>
        <button mat-raised-button color="primary" *ngIf="userSubmit" (click)="closeDialogue()">Close</button>
    </div>
    <div class="green-color" *ngIf="successMessage?.length">
        Success: <span *ngFor="let entity of successMessage;let i=index">{{entity}}
            <span *ngIf="i<(successMessage?.length-1)">,</span>
        </span>
    </div>
    <div class="red-color" *ngIf="errorMessage?.length">
        Error: <span *ngFor="let entity of errorMessage;let i=index">{{entity}}
            <span *ngIf="i<(errorMessage?.length-1)">,</span>
        </span>
    </div>
</div>